<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_list_licenses>Список лицензий</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Сформировать документ</li>
        </ol>
    </nav>

    <form class="form-narrow">
        <div class="form-narrow mb-4">
            <div class="mb-4">
                <div class="form-label">Выберите клиента</div>
                <v-select v-model="client"
                          :options="clients"
                          @update:modelValue="onChangeClient"
                          :reduce="name => name.id" label="name"
                          :deselectFromDropdown="false"
                          :clearable="false"
                          :searchable="false"
                          class="no-searchable">
                </v-select>
            </div>

            <div class="mb-4">
                <div class="form-label">Организация</div>
                <v-select v-model="organization"
                          :options="organizations"
                          :reduce="name => name.id" label="name"
                          :deselectFromDropdown="false"
                          :clearable="false"
                          :searchable="false"
                          class="no-searchable">
                </v-select>
            </div>

            <div class="form-label form-label_lg">Выберите отчётный период</div>
            <div class="row">
                <div class="col-6">
                    <div class="form-label">Дата начала</div>
                    <!-- Используется вместе с иипортированным методом из js/utilites.js dateFormat -->
<!--                    <VueDatePicker v-model="date" locale="ru" :action-row="{ showSelect: false, showCancel: false }"-->
<!--                                   :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"-->
<!--                                   :format="dateFormat" :teleport="true">-->
<!--                        <template #input-icon>-->
<!--                            <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"-->
<!--                                 xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"-->
<!--                                      d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />-->
<!--                            </svg>-->
<!--                        </template>-->
<!--                    </VueDatePicker>-->

                    <input
                        v-model="dateFrom"
                        @change="onChangeDate($event)"
                        id="dateFrom"
                        type="date"
                        class="form-control mb-3">
                </div>
                <div class="col-6">
                    <div class="form-label">Дата окончания</div>
                    <!-- Используется вместе с иипортированным методом из js/utilites.js dateFormat -->
<!--                    <VueDatePicker v-model="dateEnd" locale="ru" :action-row="{ showSelect: false, showCancel: false }"-->
<!--                                   :enable-time-picker="false" :clearable="false" auto-apply menu-class-name="custom-date-picker"-->
<!--                                   :format="dateFormat" :teleport="true">-->
<!--                        <template #input-icon>-->
<!--                            <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"-->
<!--                                 xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"-->
<!--                                      d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />-->
<!--                            </svg>-->
<!--                        </template>-->
<!--                    </VueDatePicker>-->
                    <input
                        v-model="dateTo"
                        id="dateTo"
                        type="date"
                        class="form-control mb-3">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="d-flex flex-column flex-md-row align-items-stretch py-3">
                    <!-- Пример с модалкой открывается по кнопке сохранить -->
                    <button @click="onCreate" type="button" class="btn btn-md btn-primary flex-grow-1 me-md-3 mb-3 mb-md-0">
                        Сформировать
                    </button>
                    <a href="/documents/licenses" type="button" class="btn btn-md btn-outline-dark flex-grow-1">
                        Отменить
                    </a>
                </div>
            </div>
        </div>
    </form>

    <Alert />
</template>

<script>
import { dateFormat } from '../../../../utilites';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "CreateAccountingDocumentsReport",
    components: { Alert },
    props: {
        list_accounting_documents: String,
        route_list_licenses: String
    },
    data: function () {
        return {
            dateFrom: null,
            dateTo: null,
            client: null,
            organization: null,
            clients: [],
            organizations: [],
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        dateFormat,
        getClients: async function() {
            const response = await axios.get('/organizational/client/list', {
                params: {
                    page: 1,
                    limit: 100
                }}).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список клиентов, что-то пошло не так' });
            });

            if (response.data.status === 'ok') {
                this.clients = response.data.items;
            }

            if (response.data.status !== 'ok') {
                alert(response.data.message);
            }
        },
        getOrganizations: async function () {
            let resp = await axios.get('/organizational/organizations/list', {
                params: {
                    page: 1,
                    limit: 100,
                    client_id: this.client
                }}).catch(_ => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список организаций, что то пошло не так' });
            });

            if (resp.data.status === 'ok') {
                this.organizations = resp.data.items;
            }
        },
        onCreate: async function() {

            if (!this.client) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите клиента!' });
                return;
            }

            if (!this.organization) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите организацию!' });
                return;
            }

            if (!this.dateFrom || !this.dateTo) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите отчётный период!' });
                return;
            }

            const data = await axios.post('/documents/licenses/create-account', {
                client_id: this.client,
                org_id: this.organization,
                from: this.dateFrom,
                to: this.dateTo,
            }).then(resp => {
                if (resp.data.status === 'ok') {
                    if (window.confirm('Документы успешно сформированы.\nФайлы доступны в разделе Отчетные документы.\nПерейти в раздел?')) {
                        window.location.href = this.list_accounting_documents;
                    }
                }

                if (resp.data.status && resp.data.status === 'error') {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
                }
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось сформировать документы, что то пошло не так' });
            });
        },
        onChangeClient: async function (client_id) {
            this.client = client_id;
            this.getOrganizations();
        },
        onChangeDate: async function(e) {
            const selectedDateFrom = new Date(e.target.value);
            selectedDateFrom.setDate(selectedDateFrom.getDate() + 1);
            const $date = selectedDateFrom.toISOString().slice(0, 10);
            document.getElementById('dateTo').setAttribute('min', $date);
            document.getElementById('dateTo').value = '';
        },
    },
    mounted () {
        this.getClients();
    }
};
</script>
